import {
  Activity,
  Boxes,
  Building2,
  Database,
  DollarSign,
  GitMerge,
  Globe2,
  HeartPulse,
  LayoutDashboard,
  type LucideIcon,
  PackageSearch,
  RotateCcw,
  ShieldAlert,
  Users,
} from "lucide-react";

// Every Hardware Hub surface shown in the left nav. Every entry routes to a real page (some are
// stubs the Wave-B agents fill in). One canonical layout per surface — no persona reshuffle.
export interface NavSurface {
  readonly path: string;
  readonly label: string;
  readonly icon: LucideIcon;
}

export const NAV_SURFACES: readonly NavSurface[] = [
  { path: "/", label: "Command Center", icon: LayoutDashboard },
  { path: "/health", label: "Fleet Health", icon: HeartPulse },
  { path: "/telemetry", label: "Live Telemetry", icon: Activity },
  { path: "/geo", label: "Geo Explorer", icon: Globe2 },
  { path: "/districts", label: "Districts", icon: Building2 },
  { path: "/customers", label: "Customers", icon: Users },
  { path: "/supply", label: "Supply Chain", icon: Boxes },
  { path: "/finance", label: "Finance", icon: DollarSign },
  { path: "/lifecycle", label: "Lifecycle", icon: RotateCcw },
  { path: "/rma", label: "RMA / Returns", icon: PackageSearch },
  { path: "/accounts", label: "Accounts", icon: ShieldAlert },
  { path: "/reconcile", label: "Reconciliation", icon: GitMerge },
  { path: "/data-sources", label: "Data Sources", icon: Database },
] as const;
